export const flaggedFilter = "mXa";
export default {flaggedFilter};